import { authPaths } from '@features/auth';
import { homePaths } from '@features/home';
import { dashboardPaths } from "@features/dashboard";

export const paths = {
    dashboard: dashboardPaths,
    home: homePaths,
    auth: authPaths
}